import {Archive} from 'lucide-react';
import {useTranslation} from 'react-i18next';

import {Alert, AlertDescription} from '@/components/ui/alert';

const ArchivedTaskNotice = () => {
  const {t} = useTranslation();

  return (
    <Alert>
      <Archive />
      <AlertDescription>
        {t(
          'This task is part of a care record that has been archived. Archived months are kept as they were and can no longer be changed.'
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ArchivedTaskNotice;
